import { useLayoutEffect, useState, type RefObject } from 'react';

/**
 * Whether the box's content is taller or wider than the box, followed as the box and its children resize; a box that
 * scrolls is a focusable region, so a keyboard can scroll it (axe scrollable-region-focusable). content changes
 * whenever the box mounts or what it holds changes, so that the box in place is the one observed.
 */
export function useScrolls(ref: RefObject<HTMLElement | null>, content: unknown): boolean {
  const [scrolls, setScrolls] = useState(false);
  useLayoutEffect(() => {
    const box = ref.current;
    if (!box) return;
    const check = () =>
      setScrolls(box.scrollHeight > box.clientHeight || box.scrollWidth > box.clientWidth);
    check();
    const observer = new ResizeObserver(check);
    observer.observe(box);
    for (const child of box.children) observer.observe(child);
    return () => observer.disconnect();
  }, [ref, content]);
  return scrolls;
}
